import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sectionOneData: {
    studentType: "partnership",
    email: "",
    phoneNo: "",
    linkedIn: "",
    firstName: "",
    middleName: "",
    lastName: "",
    stateName: "",
    city: "",
    hometown: "",
    gender: "",
    isEmailExist: false,
  },
  sectionTwoData: {
    referenceAssociateName: "",
    referenceAssociateId: "",
    nameOfCollege: "",
    nameOfBranch: "",
    collegeRollNo: "",
    passoutBatch: "",
    university: "",
    collegeCity: "",
    collegeState: "",
    collegeId: "",
    branchId: "",
  },
  currentSection: 1,
  collegeData: [],
  //   sectionThreeData: {},
};

const resgistrationSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setSectionOneDataFun: (state, action) => {
      state.sectionOneData = action.payload;
    },
    setSectionTwoData: (state, action) => {
      state.sectionTwoData = action.payload;
    },
    // setSectionThreeData: (state, action) => {
    //   state.sectionThreeData = action.payload;
    // },
    setCurrentSection: (state, action) => {
      state.currentSection = action.payload;
    },
    setCollegeData: (state, action) => {
      state.collegeData = action.payload;
    },
    resetForm: (state) => {
      state.sectionOneData = {};
      state.sectionTwoData = {};
      state.currentSection = 1;
    },
  },
});

export const {
  setSectionOneDataFun,
  setSectionTwoData,
  // setSectionThreeData,
  resetForm,
  setCurrentSection,
  setCollegeData,
} = resgistrationSlice.actions;

export default resgistrationSlice.reducer;
